

export const getFileImage = (myFile: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const myTarget = e.target as any;
      if (myTarget && myTarget.result) {
        return resolve(myTarget.result as string);
      }
      return resolve('');
    }

    reader.readAsDataURL(myFile);
  })
}
